export type AddressResult = {
    postcode: string;
    number: string;
    street: string;
    town: string;
};

export const getAddress = async (
    postcode: string,
    number: string,
): Promise<AddressResult> => {
    if (postcode && number) {
        const res = await fetch(`/api/account/lookup?postcode=${postcode}&number=${number}`);
        if (res.ok) {
            const data = await res.json();
            if (data.hasOwnProperty('street')) {
                return {
                    postcode: data.zip,
                    number: data.number,
                    street: data.street,
                    town: data.city,
                }
            }
        }
    }

    return {
        postcode: '',
        number: '',
        street: '',
        town: '',
    }
};